<template>
<v-dialog
    v-model="dialog"
    max-width="1200"
    v-if="note != null"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            <v-text-field
                label="Subject"
                v-model="note.subject"
                autofocus
                autocomplete="off"
            />

            <v-textarea
                label="Body"
                v-model="note.body"
                auto-grow
            />

            <v-checkbox
                label="Archive"
                v-model="note.is_archived"
                style="margin-top: -15px"
            />

            <v-checkbox
                label="Acknowledge before access (sign in as)"
                v-model="note.ack_before_access"
                style="margin-top: -15px"
            />

            <m-edit-blobs
                label="Attachments"
                v-model="note.blob_ids"
                :process_media="false"
                :externally_visible="false"
                empty_text="No attachments"
                purpose="red-chirp-crm-note-attachment"
            />

        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                v-on:click="onClickAutoStyle"
            >
                Auto Style
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            {{ok_btn_label}}
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            dialog: false,

            is_create: false,
            note: null,
        }
    },

    methods: {

        showDialog(existing_note_id)
        {
            if ( existing_note_id == null )
            {
                this.is_create = true;
                this.note = {
                    'organization_id': this.organization_id,
                    'note_id': this.$rc.uuidv4(),
                    'is_archived': false,
                    'ack_before_access': false,
                    'limits': 'none',
                    'subject': null,
                    'body': '',
                    'blob_ids': [],
                };

                this.dialog = true;
            }
            else
            {
                this.is_create = false;

                this.$rc.showSpinner();
                
                this.$rc.rest(
                    'GET: /api/v1/red-chirp-crm/notes/most-recent/:note_id',
                
                    {
                        'note_id': existing_note_id,
                    },
                
                    (data) => {
                        this.$rc.hideSpinner();
                        this.note = data;

                        this.dialog = true;
                    },
                
                    () => {
                        this.$rc.hideSpinner();
                        this.$rc.alert('Error','Unable to get note for editing');
                    },
                );
            }
            
        },

        onOk()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/red-chirp-crm/notes',
            
                this.note,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.dialog = false;
                    this.$emit('ok');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );

            
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickAutoStyle()
        {
            let ret = this.note.body;

            if ( ret == null )
                return;

            ret = ret.replaceAll('\r','\n');

            let count = 0;
            while( ret.includes('\n\n') )
            {
                count++;
                if ( count > 10 ) break; // safety...
                ret = ret.replaceAll('\n\n','\n');
                ret = ret.replaceAll(/^\s*$/gm,'');
            }

            ret = ret.replaceAll(/^.*:$/gm, (el) => { return '\n'+el; });
            ret = ret.trim();
        


            this.note.body = ret;
        }
    },

    computed: {
        ok_btn_label() {
            return this.is_create ? 'Create' : 'Save'; 
        },

        title() {
            return this.is_create ? 'Create Note' : 'Edit Note'; 
        },

        is_valid() {
            if ( this.note.subject == null ) return false;

            return true;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>